import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  access_token: string | null;
  refresh_token: string | null;
  profilePicture?: string;
}

const initialState: UserState = {
  access_token: null,
  refresh_token: null,
  profilePicture: 'https://res.cloudinary.com/dw7fvs6i2/image/upload/v1747148693/default_gpypvh.jpg',
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logoutUser: (state) => {
      state.access_token = null;
      state.refresh_token = null;
      state.profilePicture = "";
    },
    setProfilePicture: (state, action: PayloadAction<string>) => {
      state.profilePicture = action.payload;
    },
    // You can add loginUser or setTokens here if needed later
  },
});

export const { logoutUser, setProfilePicture } = userSlice.actions;

export default userSlice.reducer;
